<template>
  <div class="wrapper">
    <side-bar :sidebarLinks="sidebar_item">
      <template v-if="sidebar_item.length > 0" slot="links">
        <sidebar-link
          v-for="(val, index) in sidebar_item"
          :key="'sidebar' + index"
          :to="{ name: val.routeName }"
          :name="val.name"
          :icon="val.icon"
          :alignmentIcon="val.alignmentIcon"
          :customClass="val.activeClass"
        />
      </template>
      <mobile-menu>
        <drop-down
          alignmentIcon="left"
          class="nav-item"
          title="تنظیمات"
          title-classes="nav-link"
          icon="fas fa-cog"
        >
          <router-link :to="{ name: 'home_settings' }" class="dropdown-item"
            >صفحه اصلی</router-link
          >
          <router-link :to="{ name: 'versions' }" class="dropdown-item"
            >تنظیمات ورژن</router-link
          >
        </drop-down>
        <li class="nav-item">
          <a @click.prevent="logout_user" class="nav-link text-danger font-16">
            خروج
            <i class="fas fa-sign-out-alt" />
          </a>
        </li>
        <li class="divider" />
      </mobile-menu>
    </side-bar>
    <div id="main-panel" class="main-panel">
      <top-navbar />

      <dashboard-content @click.native="toggleSidebar" />

      <AppGoToTop />
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { mapActions } from "vuex";
import AppGoToTop from "../../components/AppGoToTop";
export default {
  data() {
    return {
      ...mapActions("main", ["logout"]),
      sidebar_item: [
        {
          name: "داشبورد",
          routeName: "dashboard",
          icon: "ti-panel",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "تنظیمات بنرها",
          routeName: "home_settings",
          icon: "fas fa-home",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "مدیریت کاربران",
          routeName: "users",
          icon: "fas fa-users",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "مدیریت دسته بندی ها",
          routeName: "categories",
          icon: "fa fa-list-alt",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "داستان ها",
          routeName: "stories",
          icon: "far fa-kiss-beam",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "کتاب ها",
          routeName: "books",
          icon: "far fa-kiss-beam",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "متن قصه ها",
          routeName: "contents",
          icon: "far fa-copy",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "مدیریت نظرات",
          routeName: "comments",
          icon: "far fa-comments",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "مدیریت اشتراک",
          routeName: "plans",
          icon: "fas fa-store",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "کدتخفیف",
          routeName: "vouchers",
          icon: "fas fa-gift",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "پرداخت ها",
          routeName: "orders",
          icon: "fas fa-money-bill-wave",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "مدیریت آواتارها",
          routeName: "avatars",
          icon: "fas fa-portrait",
          alignmentIcon: "right",
          activeClass: ""
        },
        {
          name: "ارسال پوش نوتیفیکیشن",
          routeName: "pushnotif",
          icon: "fas fa-portrait",
          alignmentIcon: "right",
          activeClass: ""
        }
      ]
    };
  },
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
    AppGoToTop
  },
  // handleActive() {
  //   const route = this.$route.name
  //   this.sidebar_item.map((val) => {
  //     val.activeClass = ''
  //     if (route === val.routeName)
  //       val.activeClass = 'active'
  //
  //   })
  // },
  // mounted() {
  //   this.handleActive()
  // },
  methods: {
    logout_user() {
      return this.logout();
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  watch: {
    immediate: true
    // '$route'(to, from) {
    //   if (to.path !== from.path)
    //     this.handleActive()
    //
    // }
  }
};
</script>
